function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(0 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.7000000000000001s",
  repeatCount: "indefinite"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(45 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.6000000000000001s",
  repeatCount: "indefinite"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(90 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.5s",
  repeatCount: "indefinite"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(135 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.4s",
  repeatCount: "indefinite"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(180 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.30000000000000004s",
  repeatCount: "indefinite"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(225 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.2s",
  repeatCount: "indefinite"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(270 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "-0.1s",
  repeatCount: "indefinite"
})));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(315 50 50)"
}, React.createElement("rect", {
  x: 47,
  y: 20,
  rx: 7.5200000000000005,
  ry: 3.2,
  width: 6,
  height: 20,
  fill: "#58595b"
}, React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "0.8s",
  begin: "0s",
  repeatCount: "indefinite"
})));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "lds-spinner",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
    },
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.2777595d.svg";
export { ForwardRef as ReactComponent };